import * as yup from "yup"; // for everything

export const loginValidation = yup.object().shape({
  email: yup
    .string()
    .email("Enter a valid email address")
    .required("Email is required"),
  password: yup
    .string()
    .min(6, "Password must contain atleast 6 characters")
    .required("Enter Your Password"),
  park: yup.object().shape({
    value: yup.string().required("Park is required"),
    label: yup.string(),
  }),
});

export const createCheckupValidation = yup.object().shape({
  opHours: yup.string().required("Operating hours is required"),
  lengthOfUpperCable: yup
    .string()
    .required("Length of Upper cable is required"),
  lengthOfLowerCable: yup
    .string()
    .required("Length of Lower cable is required"),
  date: yup.date().required("Date is required"),
  type: yup.object().shape({
    value: yup.string().required("Type is required"),
    label: yup.string(),
  }),
});

export const createUserValidation = yup.object().shape({
  firstName: yup.string().required("First Name is required"),
  lastName: yup.string().required("Last Name is required"),
  dateOfBirth: yup.date().required("Date of birth is required"),
  email: yup
    .string()
    .email("Enter a valid email address")
    .required("Email is required"),
  password: yup
    .string()
    .min(6, "Password must contain atleast 6 characters")
    .required("Enter Your Password"),
  position: yup.object().shape({
    value: yup.string().required("Position is required"),
    label: yup.string(),
  }),
  rights: yup.object().shape({
    value: yup.string().required("Rights is required"),
    label: yup.string(),
  }),
  language: yup.object().shape({
    value: yup.string().required("Language is required"),
    label: yup.string(),
  }),
  park: yup.object().shape({
    value: yup.string().required("Park is required"),
    label: yup.string(),
  }),
});

export const updateUserValidation = yup.object().shape({
  firstName: yup.string().required("First Name is required"),
  lastName: yup.string().required("Last Name is required"),
  dateOfBirth: yup.date().required("Date of birth is required"),
  email: yup
    .string()
    .email("Enter a valid email address")
    .required("Email is required"),
  position: yup.object().shape({
    value: yup.string().required("Position is required"),
    label: yup.string(),
  }),
  rights: yup.object().shape({
    value: yup.string().required("Rights is required"),
    label: yup.string(),
  }),
  language: yup.object().shape({
    value: yup.string().required("Language is required"),
    label: yup.string(),
  }),
  park: yup.object().shape({
    value: yup.string().required("Park is required"),
    label: yup.string(),
  }),
});

export const resetPasswordValidation = yup.object().shape({
  password: yup
    .string()
    .min(6, "Password must contain atleast 6 characters")
    .required("Enter Your Password"),
  confirmPassword: yup
    .string()
    .required("confirm your password")
    .oneOf([yup.ref("password")], "Password does not match"),
});

export const forgotPasswordValidation = yup.object().shape({
  password: yup
    .string()
    .min(6, "Password must contain atleast 6 characters")
    .required("Enter your new password"),
  confirmPassword: yup
    .string()
    .required("confirm your password")
    .oneOf([yup.ref("password")], "Password does not match"),
  code: yup.string().required("Code is required"),
});

export const emailValidation = yup.object().shape({
  email: yup
    .string()
    .email("Enter a valid email address")
    .required("Email is required"),
});
